/**
 * Verlaufseintrag "Talent hat die Sprache des Assessments geändert".
 *
 * Die Talent-App (aivy-universal-app, src/utils/space-history-log.js) schreibt
 * den Eintrag nur bei einer bewussten Sprachwahl eines eingeloggten Talents mit
 * aktivem Space und nur, wenn sich die Sprache wirklich ändert:
 *   { status: 'ASSESSMENT_LANGUAGE_CHANGED',
 *     changes: [{ label: 'language', before: 'de', after: 'nl' }] }
 *
 * Space.language bleibt dabei unverändert, die Sprache der Einladung ist also
 * weiterhin die aus der Stelle. Reine Funktionen ohne React und Netzwerk,
 * damit das Mapping ohne Rendering testbar bleibt.
 */

import { getLanguage, isAssessmentLanguage } from '../constants/languages'

export const ASSESSMENT_LANGUAGE_CHANGED = 'ASSESSMENT_LANGUAGE_CHANGED'

const LANGUAGE_CHANGE_LABEL = 'language'

const toCode = (value) =>
  typeof value === 'string' && value.trim() ? value.trim().toLowerCase() : null

/**
 * Liest die Sprachcodes aus den changes des Logs. Bevorzugt den Eintrag mit
 * label 'language', sonst den ersten. Ohne beide Codes gibt es nichts
 * Sinnvolles anzuzeigen, dann null.
 */
export const getAssessmentLanguageChange = (changes) => {
  if (!Array.isArray(changes) || !changes.length) return null

  const change =
    changes.find((item) => item?.label === LANGUAGE_CHANGE_LABEL) || changes[0]

  const from = toCode(change?.before)
  const to = toCode(change?.after)

  if (!from || !to) return null

  return { from, to }
}

/**
 * Sprachname in der Sprache des Betrachters. Unbekannte Codes (z. B. eine
 * spätere Sprache der Talent-App) erscheinen als Kürzel in Großbuchstaben.
 */
export const getAssessmentLanguageName = (code, t) =>
  isAssessmentLanguage(code) ? t(getLanguage(code)) : String(code).toUpperCase()

/**
 * Interpolationswerte für pages.talent.ASSESSMENT_LANGUAGE_CHANGED oder null,
 * wenn der Log keine lesbare Änderung enthält.
 */
export const getAssessmentLanguageChangeLabels = (changes, t) => {
  const change = getAssessmentLanguageChange(changes)
  if (!change) return null

  return {
    from: getAssessmentLanguageName(change.from, t),
    to: getAssessmentLanguageName(change.to, t)
  }
}
